module.exports = __webpack_public_path__ + "img/3.bf2faaaa.webp";